import { T } from "@supersig/validate";
/**
 * The colors used by tldraw's default shapes.
 *
 *  @public */ export const TL_CANVAS_UI_COLOR_TYPES = new Set([
    "accent",
    "white",
    "black",
    "selection-stroke",
    "selection-fill",
    "laser",
    "muted-1"
]);
/**
 * A validator for the colors used by tldraw's default shapes.
 *
 * @public */ export const canvasUiColorTypeValidator = T.setEnum(TL_CANVAS_UI_COLOR_TYPES);
